import "core-js/modules/es.number.constructor.js";
export default {
  name: "goodsOptions",
  props: {
    type: Number,
    goodsArray: Array,
    value: [Array, String, Number]
  },
  computed: {
    label: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit("input", val);
      }
    }
  },
  data: function data() {
    return {
      // label: this.value,
    };
  },
  methods: {
    // someSelect() {
    // this.$emit("input", this.label);
    // },
  }
};